import confirmDialogVar, { getInitialData } from './variables';
import { useCallback } from 'react';

const useConfirmDialog = () => {
  const confirm = useCallback(
    (callback, options = {}) => confirmDialogVar({ open: true, callback, options: { ...getInitialData().options, ...options } }),
    []
  );

  return confirm;
};

export default useConfirmDialog;
